<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Timeline</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="timeline-main-section col-12 float-l default-bx-shadow">
                    <div class="row">

                        <div class="timeline"> <!--Time line-->
                            <div class="row justify-content-end justify-content-md-around align-items-start  timeline-nodes"> <!--left side-->
                                <div class="col-10 col-md-5 order-3 order-md-1 timeline-content">
                                    <h3>Lorem ipsum</h3>
                                    <h5> 11 hours ago via Twitter</h5>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Libero laboriosam dolor perspiciatis omnis exercitationem. Beatae, officia pariatur? Est cum veniam excepturi. Maiores praesentium, porro voluptas suscipit facere rem dicta, debitis.</p>
                                </div>
                                <div class="col-2 col-sm-1 order-2 timeline-image text-md-center">
                                    <img src="/static/images/avtar-img.jpg" class="img-fluid" alt="img">
                                </div>
                                <div class="col-10 col-md-5 order-1 order-md-3 py-3 timeline-date">

                                </div>
                            </div> <!--left side-->

                            <div class="row justify-content-end justify-content-md-around align-items-start  timeline-nodes"> <!--right side-->
                                <div class="col-10 col-md-5 order-3 order-md-1 timeline-content">
                                    <h3>Lorem ipsum</h3>
                                    <h5> 11 hours ago via Twitter</h5>
                                    <img class="timeline-img" src="/static/images/timeline-demo-img.jpg">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Libero laboriosam dolor perspiciatis omnis exercitationem. Beatae, officia pariatur? Est cum veniam excepturi. Maiores praesentium, porro voluptas suscipit facere rem dicta, debitis.</p>
                                </div>
                                <div class="col-2 col-sm-1 order-2 timeline-image text-md-center">
                                    <img src="/static/images/avtar-img-1.jpg" class="img-fluid" alt="img">
                                </div>
                                <div class="col-10 col-md-5 order-1 order-md-3 py-3 timeline-date">

                                </div>
                            </div> <!--right side-->

                            <div class="row justify-content-end justify-content-md-around align-items-start  timeline-nodes"> <!--left side-->
                                <div class="col-10 col-md-5 order-3 order-md-1 timeline-content">
                                    <h3>Lorem ipsum</h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Libero laboriosam dolor perspiciatis omnis exercitationem. Beatae, officia pariatur? Est cum veniam excepturi. Maiores praesentium, porro voluptas suscipit facere rem dicta, debitis.</p>
                                </div>
                                <div class="col-2 col-sm-1 order-2 timeline-image text-md-center">
                                    <i class="hi-icon icon-abmsettings bg-color-29a3b0 timeline-icon"> </i>
                                </div>
                                <div class="col-10 col-md-5 order-1 order-md-3 py-3 timeline-date">

                                </div>
                            </div> <!--left side-->

                            <div class="row justify-content-end justify-content-md-around align-items-start  timeline-nodes"> <!--right side-->
                                <div class="col-10 col-md-5 order-3 order-md-1 timeline-content">
                                    <h3>Lorem ipsum</h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Libero laboriosam dolor perspiciatis omnis exercitationem. Beatae, officia pariatur? Est cum veniam excepturi. Maiores praesentium, porro voluptas suscipit facere rem dicta, debitis.</p>
                                </div>
                                <div class="col-2 col-sm-1 order-2 timeline-image text-md-center">
                                    <i class="hi-icon icon-abmweb bg-color-d7757c timeline-icon"> </i>
                                </div>
                                <div class="col-10 col-md-5 order-1 order-md-3 py-3 timeline-date">

                                </div>
                            </div> <!--right side-->

                        </div> <!--Time line-->

                    </div>
                </div>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/footer';

    export default {
        name: 'Center',
        components: {
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
            }

        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/timeline.vue